'use client';
import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { faqData } from '@/lib/data';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleItem = (index: number) => {
    setOpenIndex(prev => (prev === index ? null : index));
  };

  return (
    <>
      <section id="faq" className="py-20 bg-white">
          <div className="mx-4">

        <div className="container mx-auto max-w-8xl">
        <hr style={{ borderColor: '#ACD2D2', borderWidth: '1px', marginBottom:'25px'}} />

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">

            <div className="lg:col-span-4">
              <h2 id="faq-heading" className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-[#005e60] font-sofia-sans-condensed mt-7 ">
                FREQUENTLY ASKED<br />
                QUESTIONS
              </h2>
            </div>

            <div className="lg:col-span-8">
              <div className="space-y-0">
                {faqData.map((item, index) => (
                  <div key={index} className="border-b border-[#005e60]">
                    <button
                      onClick={() => toggleItem(index)}
                      className="w-full py-6 flex justify-between items-start text-left transition-colors duration-200 cursor-pointer"
                    >
                      <span className="text-lg md:text-xl text-[#005e60] font-medium pr-4 leading-relaxed">
                        {item.question}
                      </span>
                      <div className="flex-shrink-0 mt-1">
                        {openIndex === index ? (
                          <Minus className="w-6 h-6 text-[#005e60]" />
                        ) : (
                          <Plus className="w-6 h-6 text-[#005e60]" />
                        )}
                      </div>
                    </button>

                    {openIndex === index && (
                      <div className="pb-6 pr-10">
                        <p className="faq-answer text-gray-700 text-base md:text-lg leading-relaxed" dangerouslySetInnerHTML={{ __html: item.answer }} />
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>

          </div>
          </div>

        </div>
      </section>
      <style jsx>{`
        .text-gray-700 a {
          color: #005E60;
          text-decoration: underline;
          transition: color 0.2s;
        }
        .text-gray-700 a:hover {
          color: #005E60;
          text-decoration: underline;
          opacity: 0.8;
        }
      `}</style>
    </>
  );
};

export default FAQ;
